module.exports = __webpack_public_path__ + "media/images/logo_text_pl-1b93318d4a1e4faf78b54034f692b55b.svg";